import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateIntegrationOptionValueV3 = OpalApi<
  'CreateIntegrationOptionValueV3',
  201
>

export const createIntegrationOptionValue: CreateIntegrationOptionValueV3 =
  async (args = {}) => {
    const url = new URL('/v3/integration_option_values', window.location.origin)

    return HttpClient()
      .post(url.toString(), args.requestBody)
      .then((res) => res.data)
  }
